<template>
	<div>
		<table-editable-list :columns="columns"
												 :show-select="false"
												 :show-actions="false">
			<template slot="data-row">
				<template v-for="(detail, idx) in assessmentDetails">
					<table-list-row :key="`score_${idx}`"
													:columns="columns"
													:rowdata="detail"
													:rowIndex="idx"
													v-if="detail.SCORE !== ''"
													:showActions="false">
					</table-list-row>
				</template>
			</template>
		</table-editable-list>
		<!-- Return back button -->
		<div class="back-link">
			<a style="cursor:pointer" @click="$router.go(-1)">
				<i class="fas fa-caret-left" aria-hidden="true"></i>{{ $t('MAIN_CONTENT.commonContent.goBack') }}
			</a>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Assessments from '../api/Assessments.js';

	import TableEditableList from 'COMMONS/tables/TableEditableList.vue';
	import TableListRow from 'COMMONS/tables/TableListRow.vue';

	export default {
		data() {
			return {
				title: '',
				assessmentDetails: [],
				columns: [
					{
						heading: this.$t( 'MAIN_CONTENT.AssessmentScoresDetails.column' ),
						key: 'COLUMN_HEADING',
						customCol: 'column'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.AssessmentScoresDetails.columnDesc' ),
						key: 'COLUMN_DESC',
						customCol: 'description'
					},
					{
						heading: this.$t( 'MAIN_CONTENT.AssessmentScoresDetails.score' ),
						key: 'SCORE',
						customCol: 'score'
					}
				]
			};
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules', 'role'])
		},
		components: {
			TableEditableList,
			TableListRow
		},
		methods: {
			loadAssessmentDetails() {
				const self = this;

				let assessment = new Assessments({
					route: 'assessments/columns',
					query: {
						student_rid: self.selectedStudent.STUDENT_RID,
						assessment_type_rid: self.$route.params.assessmentTypeRID,
						assessment_rid: self.$route.params.assessmentRID,
						type: 'AS'
					}
				});

				const promise = assessment.get();

				promise.then(response => {
					self.$set(self, 'assessmentDetails', response.data.data);
					self.loadAssessmentScores();
				})
				.catch(error => {
					console.log(error);
				});
			},
			loadAssessmentScores() {
				const self = this;

				let assessment = new Assessments({
					route: 'assessments',
					query: {
						student_rid: this.selectedStudent.STUDENT_RID
					}
				});

				const promise = assessment.get();

				promise.then(response => {
					for(let i in response.data.data) {
						let assessmentTypes = response.data.data[i];

						for(let t in assessmentTypes.ASSESSMENT_TYPES) {
							let assessmentType = assessmentTypes.ASSESSMENT_TYPES[t];

							if(+assessmentType.ASSESSMENT_TYPE_RID === +self.$route.params.assessmentTypeRID) {
								for(let a in assessmentType.ASSESSMENT_TESTS) {
									let test = assessmentType.ASSESSMENT_TESTS[a];

									if(+test.ASSESSMENT_RID === +self.$route.params.assessmentRID) {
										self.$store.commit('setTitle', self.$t('MAIN_CONTENT.AssessmentScoresDetails.assessmentScoresWithColon', { name: test.ASSESSMENT_INSTANCE_NAME } ) );
										self.$store.commit('setUseHeader', true);
										break;
									}
								}
							}
						}
					}
				})
				.catch(error => {
					console.log(error);
				});
			}
		},
		created() {
			this.$store.commit('setTitleIcon', 'align-center');

			if(this.roleRules.ASSESSMENTS_FLG === 'Y' && this.roleRules.ASSESSMENTS_DETAILS_FLG === 'Y') {
				this.loadAssessmentDetails();
			} else {
				this.roleRules.ASSESSMENTS_FLG === 'Y' ?
					this.$router.push({ name: 'AssessmentScores' }) : this.$router.push({ name: 'HomePage' });
			}
		}
	}
</script>
